import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";

/**
 * @param data        массив данных
 * @param groupBy     поле верхнего уровня (category / type / manufacturer)
 * @param valueBy     поле второго уровня (type / manufacturer)
 */
export default function ComponentTreemap({
    data,
    groupBy = "category",
    valueBy = "type"
}) {
    const treeData = useMemo(() => {
        if (!Array.isArray(data)) return [];

        const map = {};

        data.forEach(item => {
            const groupKey = item[groupBy] || "Не указано";
            const valueKey = item[valueBy] || "Не указано";
            const cnt = item.cnt || 0;

            if (!map[groupKey]) {
                map[groupKey] = {};
            }
            map[groupKey][valueKey] =
                (map[groupKey][valueKey] || 0) + cnt;
        });

        return Object.entries(map).map(([group, values]) => ({
            name: group,
            children: Object.entries(values).map(([name, value]) => ({
                name,
                value
            }))
        }));
    }, [data, groupBy, valueBy]);

    const getLevelOption = () => [
        {
            itemStyle: {
                borderWidth: 0,
                gapWidth: 6
            }
        },
        {
            itemStyle: {
                gapWidth: 2
            }
        },
        {
            colorSaturation: [0.35, 0.6],
            itemStyle: {
                gapWidth: 2,
                borderColorSaturation: 0.7
            }
        }
    ];

    const option = {
        tooltip: {
            formatter: (info) => {
                const value = info.value;
                const path = info.treePathInfo
                    .slice(1)
                    .map(p => p.name)
                    .join(" / ");

                return `
                    <b>${echarts.format.encodeHTML(path)}</b><br/>
                    ${echarts.format.addCommas(value)} шт.
                `;
            }
        },

        series: [
            {
                type: "treemap",
                visibleMin: 1,
                label: {
                    show: true,
                    formatter: "{b}"
                },
                upperLabel: {
                    show: true,
                    height: 24
                },
                itemStyle: {
                    borderColor: "#fff"
                },
                levels: getLevelOption(),
                data: treeData
            }
        ]
    };

    return (
        <ReactECharts
            option={option}
            style={{ height: 440, width: "100%" }}
        />
    );
}
